import { cn } from "@/lib/utils";
import { Globe } from "lucide-react";
import type { SVGProps } from "react";

/** Generic company website marketplace listing icon. */
export function WebsiteIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return <Globe className={cn("shrink-0", className)} aria-hidden {...props} />;
}
